var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('meta',{attrs:{"name":"description","content":"Jozef Ostyn, Vice-Gouverneur van het administratief arrondissement Brussel-Hoofdstad"}}),_c('meta',{attrs:{"name":"robots","content":"index, follow"}})])
}]

export { render, staticRenderFns }